export const TODAY = 'TODAY';
export const WEEK = 'WEEK';
export const MONTH = 'MONTH';
export const ALL = 'ALL';

export const DATE_RANGE = {
  pastDue: 'PAST_DUE',
  today: 'TODAY',
  week: 'WEEK',
  month: 'MONTH',
  all: 'ALL'
};
